<template>
	<div class="page-check-list">
		<!-- 头部: 标题 + 设备数量 + 刷新按钮 -->
		<div class="header">
			<div class="header-info">
				<div class="header-title">待质检列表</div>
				<div class="header-count">当前共检测到{{ list.length }}台设备</div>
			</div>
			<div class="header-refresh-btn" @click="onclickRefreshBtn">刷 新</div>
		</div>

		<!-- 设备列表 -->
		<div class="list">
			<div class="item" v-for="(item, index) in list" :key="index">
				<div class="item-left">
					<img class="icon-feeder" :src="ossPondHost + 'img/xiazeng_icon.png'" />
					<div class="item-num">{{ item.displayNum }}</div>
					<i v-if="item.passed" class="item-checked van-icon van-icon-checked"></i>
				</div>
				<div v-if="item.qcDone" class="item-done">已出厂</div>
				<template v-else>
					<div class="item-btn" @click.stop="onclickLightBtn(index)">亮灯</div>
					<div v-if="item.passed" class="item-btn" @click="onclickGoQaBtn(index)">查看</div>
					<div v-else class="item-btn" @click="onclickGoQaBtn(index)">去质检</div>
				</template>
			</div>
		</div>

		<!-- 空状态 -->
		<div class="list-tip" v-if="!list.length">暂无待质检设备，请将设备通电</div>

		<!-- 底部提交按钮 -->
		<div class="footer">
			<div :class="['btn-submit', { disabled: !canSubmitCount }]" @click="onclickSubmitBtn">
				提交质检({{ canSubmitCount }}/{{ unfinishedCount }})
			</div>
		</div>
	</div>
</template>

<script>
import { Dialog, Toast } from 'vant';
export default {
	name: 'XiazengCheckList',
	data() {
		const { ossHostPond } = this.$config.base;
		return {
			ossPondHost: ossHostPond,
			list: [],
			// 可提交质检的设备数
			canSubmitCount: 0,
			// 未出厂设备总数
			unfinishedCount: 0,
			// 提交中
			submitting: false,
		};
	},
	created() {
		this.loadCheckList();
	},
	methods: {
		// 编号只展示后六位, 前面加...; 空值原样返回
		maskLastSix(num) {
			return num && num.length > 6 ? '...' + num.slice(-6) : (num || '');
		},

		// 获取设备列表
		loadCheckList() {
			const vm = this;
			const toast = Toast.loading({ message: '加载中', forbidClick: true, duration: 0 });
			vm.$http({
				method: 'GET',
				url: vm.$config.base.XIAZENG_BASE_URL + 'xia/factory/devices',
				params: { online: true },
			}).then(res => {
				toast.clear();
				const devices = (res.data && res.data.devices) || [];
				const list = Array.isArray(devices) ? devices : [];
				let canSubmitCount = 0;
				list.forEach(item => {
					const ps = item.processState || {};
					// 质检通过: 配置成功 + 打样完成 + 按键已检测 + 正式注册成功
					item.passed = ps.configState === 'SUCCESS' && ps.sampleState === 'COMPLETED' && ps.buttonChecked === true && ps.formalRegisterState === 'SUCCESS';
					// 展示编号: 已通过显示 serverUniqueId; 未通过优先 imei, 无 imei 用 iccid, 均只展示后六位
					item.displayNum = item.passed
						? (ps.serverUniqueId || '')
						: vm.maskLastSix(item.imei || item.iccid);
					if (item.passed && !item.qcDone) {
						canSubmitCount++;
					}
				});
				vm.list = list;
				vm.canSubmitCount = canSubmitCount;
				vm.unfinishedCount = list.filter(item => !item.qcDone).length;
			}).catch(() => {
				toast.clear();
			});
		},

		// 点击刷新按钮
		onclickRefreshBtn() {
			this.loadCheckList();
		},

		// 点击亮灯
		onclickLightBtn(index) {
			const vm = this;
			const item = vm.list[index];
			if (!item.iccid) {
				Toast('设备ICCID为空');
				return;
			}
			const toast = Toast.loading({ message: '亮灯中...', forbidClick: true, duration: 0 });
			vm.$http({
				method: 'POST',
				url: vm.$config.base.XIAZENG_BASE_URL + `xia/factory/device/${item.iccid}/light/blink?duration=5`,
			}).then(() => {
				toast.clear();
				Toast('设备指示灯已闪烁');
			}).catch(() => {
				toast.clear();
			});
		},

		// 点击去质检/查看 - 跳转单台质检详情
		onclickGoQaBtn(index) {
			sessionStorage.setItem('xiazengCheckList', JSON.stringify(this.list));
			this.$router.push({
				path: './qaEngine',
				query: { index, mode: 'check' },
			});
		},

		// 点击提交质检按钮
		onclickSubmitBtn() {
			const vm = this;
			if (!vm.canSubmitCount || vm.submitting) return;
			Dialog.confirm({
				title: '提交质检',
				message: `当前有${vm.canSubmitCount}台设备已通过质检，是否提交出厂？`,
				confirmButtonText: '提 交',
				cancelButtonText: '取 消',
			}).then(() => {
				vm.doSubmitAll();
			}).catch(() => {});
		},

		// 逐台提交质检 - 调用 confirmServerLogin 确认正式服务登录
		doSubmitAll() {
			const vm = this;
			const submitList = vm.list.filter(item => item.passed && !item.qcDone);
			if (!submitList.length) return;
			vm.submitting = true;
			let toast = Toast.loading({ message: `提交中(0/${submitList.length})`, forbidClick: true, duration: 0 });

			let index = 0;
			const submitNext = () => {
				if (index >= submitList.length) {
					toast.clear();
					vm.submitting = false;
					Toast('全部提交成功');
					vm.loadCheckList();
					return;
				}
				const item = submitList[index];
				const uniqueId = (item.processState || {}).serverUniqueId || '';
				vm.$http({
					method: 'POST',
					url: vm.$config.base.XIAZENG_BASE_URL + `xia/factory/confirmServerLogin?uniqueId=${uniqueId}`,
				}).then(() => {
					index++;
					toast.clear();
					toast = Toast.loading({ message: `提交中(${index}/${submitList.length})`, forbidClick: true, duration: 0 });
					submitNext();
				}).catch(() => {
					toast.clear();
					vm.submitting = false;
					Toast(`设备${item.iccid}提交失败`);
					vm.loadCheckList();
				});
			};
			submitNext();
		},
	},
};
</script>

<style lang="less" scoped>
@import '@/less/base.less';

.page-check-list {
	min-height: 100vh;
	background: @bgColor2;
	padding-bottom: 0.9rem;
	box-sizing: border-box;

	.header {
		padding: 0.15rem 0.1rem;
		display: flex;
		justify-content: space-between;
		align-items: center;

		&-info {
			display: flex;
			flex-direction: column;
		}

		&-title {
			color: @textColor1;
			font-weight: 500;
			font-size: 0.18rem;
			letter-spacing: 0.01rem;
			line-height: 0.25rem;
		}

		&-count {
			color: @textColor1;
			font-size: 0.16rem;
			letter-spacing: 0.01rem;
			line-height: 0.22rem;
			margin-top: 0.05rem;
		}

		&-refresh-btn {
			background: @themeColor;
			border-radius: 0.25rem;
			color: @blank;
			font-size: 0.16rem;
			letter-spacing: 0.01rem;
			line-height: 0.3rem;
			height: 0.3rem;
			width: 0.8rem;
			text-align: center;
			cursor: pointer;
		}
	}

	.list {
		margin: 0.2rem 0.1rem 0;

		.item {
			background: @blank;
			border-radius: 0.05rem;
			height: 0.8rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 0.1rem;
			box-sizing: border-box;
			margin-bottom: 0.1rem;

			&-left {
				display: flex;
				align-items: center;
			}

			.icon-feeder {
				width: 0.6rem;
				height: 0.6rem;
				margin-right: 0.1rem;
			}

			&-num {
				font-size: 0.18rem;
				color: @textColor12;
				font-weight: 500;
				letter-spacing: 0.01rem;
				line-height: 0.25rem;
				max-width: 1.9rem;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			&-checked {
				color: @themeColor;
				font-size: 0.22rem;
				margin-left: 0.08rem;
			}

			&-btn {
				border: 2px solid @themeColor;
				border-radius: 0.15rem;
				color: @themeColor;
				font-size: 0.18rem;
				letter-spacing: 0.01rem;
				line-height: 0.25rem;
				padding: 0.02rem 0.06rem;
				width: 0.57rem;
				text-align: center;
				box-sizing: content-box;
				cursor: pointer;
			}

			&-done {
				color: @textColor13;
				font-size: 0.18rem;
				font-weight: 500;
			}
		}
	}

	.list-tip {
		border-radius: 0.1rem;
		background: @blank;
		margin: 0.2rem 0.1rem 0;
		height: 2rem;
		text-align: center;
		line-height: 2rem;
		font-size: 0.18rem;
		color: @textColor13;
	}

	.footer {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		background: @bgColor2;

		.btn-submit {
			background: @themeColor;
			color: @blank;
			font-size: 0.19rem;
			font-weight: 500;
			letter-spacing: 0.02rem;
			line-height: 0.6rem;
			text-align: center;
			cursor: pointer;

			&.disabled {
				background: #C8C9CC;
				cursor: default;
			}
		}
	}
}
</style>
